import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["collapse"]

  toggle(event) {
    const clickedCheckbox = event.target

    // If we're opening this one, close all others
    if (clickedCheckbox.checked) {
      this.collapseTargets.forEach(collapse => {
        const checkbox = collapse.querySelector('input[type="checkbox"]')
        if (checkbox && checkbox !== clickedCheckbox) {
          checkbox.checked = false
        }
      })
    }
  }
}
